import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
import { DropdownItem } from "@similarweb/ui-components";

export const StyledDDContainer = styled.div`
    position: relative;

    & .DropdownContent-container {
        transform: translate(8px, -5px);
    }
`;

export const StyledDropdownItem = styled(DropdownItem)<{ disabled?: boolean }>`
    ${mixins.setFontVariant("input2")};

    color: ${({ disabled }) => !disabled && colorsPalettes.carbon["500"]};
`;
